import React, {memo} from 'react';
import {PasswordField as PwdField} from '@components/Form';

const PasswordField: React.FC = () => {
	return (
		<PwdField
			data-testid="password-field"
			name="password"
			id="password"
			context="reg"
			showLevel={true}
		/>
	);
};

export default memo(PasswordField);
